(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[477],{

/***/ 77451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ido",
      function () {
        return __webpack_require__(97606);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_div_100vh__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66409);
/* harmony import */ var _components_common_Nav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27356);
/* harmony import */ var _components_common_PageHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47270);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67841);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98786);
/* harmony import */ var _components_common_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58163);
/* harmony import */ var _services_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61839);
/* harmony import */ var _hooks_ido_useInvestInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81121);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var _components_ido_InvestmentIframe__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14224);
/* harmony import */ var _services_ido__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59498);
/* harmony import */ var _components_ido_UserInvestmentInfoDialog__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18084);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91759);















var IDO_CAMPAIGN_ID = "16";
var IDO_CAMPAIGN_SRC = "https://www.deshilling.com/public/assets/js/invest-button-iframe-52.js?no=005";
var IDOPage = function() {
    var height = (0,react_div_100vh__WEBPACK_IMPORTED_MODULE_1__/* .use100vh */ .g)();
    var ref = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), login = ref.login, isLogin = ref.isLogin, address = ref.address;
    var investInfo = (0,_hooks_ido_useInvestInfo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var locale = investInfo.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), investMode = ref1[0], setInvestMode = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useDisclosure */ .q)(false), 2), investDialogOpened = ref2[0], ref3 = ref2[1], openInvestDialog = ref3.open, closeInvestDialog = ref3.close;
    var benefits = [
        {
            Icon: _components_common_icons__WEBPACK_IMPORTED_MODULE_5__/* .DataIcon */ .d1,
            name: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("benefits.data_and_content_access", locale),
            desc: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("benefits.data_and_content_access_description", locale)
        },
        {
            Icon: _components_common_icons__WEBPACK_IMPORTED_MODULE_5__/* .GiftIcon */ .Og,
            name: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("benefits.staking_and_rewards", locale),
            desc: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("benefits.staking_and_rewards_description", locale)
        },
        {
            Icon: _components_common_icons__WEBPACK_IMPORTED_MODULE_5__/* .BuildingIcon */ .Zy,
            name: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("benefits.governance", locale),
            desc: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("benefits.governance_description", locale)
        }, 
    ];
    var introInfo = [
        {
            name: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("token_distribution.title", locale),
            items: [
                _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("token_distribution.desc1", locale),
                _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("token_distribution.desc2", locale),
                _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("token_distribution.desc3", locale), 
            ]
        },
        {
            name: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("investment_limit.title", locale),
            items: [
                _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("investment_limit.desc1", locale),
                _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("investment_limit.desc2", locale), 
            ],
            tip: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("investment_limit.tip", locale)
        }, 
    ];
    var cardClass = "rounded-lg bg-[linear-gradient(180deg,rgba(255,255,255,0.50)_0%,rgba(255,255,255,0.00)_100%)] py-7 w-[250px] flex flex-col items-center";
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        if (_services_ido__WEBPACK_IMPORTED_MODULE_10__/* .IDO_STAGE */ .J_ === _services_ido__WEBPACK_IMPORTED_MODULE_10__/* .IDOStage.ROUND_1_END */ .jA.ROUND_1_END || _services_ido__WEBPACK_IMPORTED_MODULE_10__/* .IDO_STAGE */ .J_ === _services_ido__WEBPACK_IMPORTED_MODULE_10__/* .IDOStage.ROUND_2_END */ .jA.ROUND_2_END) {
            setInvestMode(true);
        }
    }, [
        _services_ido__WEBPACK_IMPORTED_MODULE_10__/* .IDO_STAGE */ .J_
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            height: height ? "".concat(height, "px") : "100vh"
        },
        id: "container",
        className: "w-screen overflow-x-hidden overflow-y-scroll font-exo text-base bg-[url('/assets/ido/bg1.png')] bg-cover bg-no-repeat",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_PageHead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Nav__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-idoBg bg-no-repeat bg-cover -mt-[100px] flex items-center justify-center pt-[180px] pb-32 sm:pt-[267px] sm:pb-[103px]",
                children: [
                    !investMode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "py-2 px-4 flex items-center justify-center text-sm font-semibold rounded-lg ",
                                style: {
                                    background: "linear-gradient(278.55deg, #FFFFFF -6.14%, #87B5FF 93.7%, #3C86FB 157.68%)"
                                },
                                children: _services_ido__WEBPACK_IMPORTED_MODULE_10__/* .currentRound */ .H4 === 1 ? "First Round" : "Second Round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-8 text-center text-6xl sm:text-[100px] font-extrabold text-dark1 leading-none",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("initial", locale)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-primary",
                                        children: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("dex", locale)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("offering", locale)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-center gap-6 mt-8 flex-wrap",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: cardClass,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-[#639EFC] text-[28px] font-extrabold",
                                                children: _services_ido__WEBPACK_IMPORTED_MODULE_10__/* .currentRound */ .H4 === 1 ? "$0.5 Million" : " $3.5 Million"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-2 font-medium text-xl text-gray1",
                                                children: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("target_goal", locale)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: cardClass,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-[#639EFC] text-[28px] font-extrabold",
                                                children: _services_ido__WEBPACK_IMPORTED_MODULE_10__/* .currentRound */ .H4 === 1 ? "$0.03" : "$0.035"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-2 font-medium text-xl text-gray1",
                                                children: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("price", locale)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-8 text-center font-medium",
                                children: _services_ido__WEBPACK_IMPORTED_MODULE_10__/* .currentRound */ .H4 === 1 ? "July 19 - July 21" : "July 22 - August 19"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-10 flex flex-col gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Button */ .z, {
                                        className: "w-[242px]",
                                        radius: "xl",
                                        size: "xl",
                                        onClick: function() {
                                            setInvestMode(true);
                                        },
                                        children: "Join now"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Button */ .z, {
                                        className: "w-[242px] bg-white h-[56px] text-sm",
                                        radius: "xl",
                                        variant: "outline",
                                        onClick: openInvestDialog,
                                        children: "View my participation"
                                    })
                                ]
                            })
                        ]
                    }),
                    investMode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ido_InvestmentIframe__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        investInfo: investInfo,
                        campaignId: IDO_CAMPAIGN_ID,
                        campaignSrc: IDO_CAMPAIGN_SRC
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative before:opacity-40 before:bg-blend before:bg-cover before:content-[''] before:absolute before:-top-20 before:left-0 before:w-full before:h-full pt-14 sm:pt-[140px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center relative z-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "selection:text-fill-white text-[32px] font-extrabold w-[95%] sm:w-[80%] max-w-[615px] text-center sm:text-5xl !leading-tight",
                                style: {
                                    background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                                    backgroundClip: "text",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent"
                                },
                                children: _services_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].t */ .Z.t("benefits.staking_benefits", locale)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex gap-4 mt-11 flex-wrap justify-center px-5 sm:px-0",
                                children: benefits.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sm:w-[362px] bg-tertiary rounded-2xl px-8 py-14",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.Icon, {
                                                className: "w-12 h-12 fill-primary"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-[70px] text-white text-[32px] font-extrabold leading-[1.1]",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-white font-medium text-lg mt-4",
                                                children: item.desc
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-wrap justify-center gap-[78px] mt-20 sm:mt-[163px] relative z-10 px-5 sm:px-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/assets/ido/star2.png",
                                className: "absolute top-[-104px] left-[102px] hidden sm:block"
                            }),
                            introInfo.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "sm:w-[445px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-[32px] font-extrabold text-gray1 text-center",
                                            children: item.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-8 flex flex-col gap-4 font-medium",
                                            children: item.items.map(function(item, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mr-1",
                                                            children: "・"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            children: item
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        }),
                                        item.tip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-sm mt-8 font-medium text-gray1",
                                            children: item.tip
                                        })
                                    ]
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "mt-10",
                        src: "/assets/ido/rocket.png",
                        width: 220
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/ido/radial.png",
                        className: "absolute bottom-[315px] right-[77px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/ido/start1.png",
                        className: "absolute bottom-[61px] right-[398px]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ido_UserInvestmentInfoDialog__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                opened: investDialogOpened,
                close: closeInvestDialog,
                campaignId: IDO_CAMPAIGN_ID
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (IDOPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3454,2280,6034,7258,4304,7172,2256,7356,7603,9774,2888,179], function() { return __webpack_exec__(77451); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);